export default __webpack_public_path__ + "static/media/elevate-bbl-poster-2.f0414203.jpg";